import {post} from '@/utils/network';

// 获取选修课列表
export function getTakeCourse(params: {coid: string}) {
  return post('futurev2/NoAuth/getTakeCourse', params)
}

// 批量添加选修课 多个用,隔开
export function batchAddClass(params: { courseid: string }) {
  return post('CourseApi/batchAddClass', params)
}

